import { useState } from "react";
import { Space, Typography, Popconfirm, Select, Card, Tooltip } from "antd";
import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { 
  PermissionedButton, 
} from "../../PermissionedComponents";
import { getColorStrategyLockReason } from "@utils/color_utils";

const { Option } = Select;

export const ColorStrategyManagement = ({ 
  strategies, 
  currentUserId,
  onAdd, 
  onEdit, 
  onDelete 
}) => {
  const [selectedStrategyId, setSelectedStrategyId] = useState(null);

  // Get the currently selected strategy object
  const selectedStrategy = strategies.find(strategy => strategy.id === selectedStrategyId);
  const lockReason = selectedStrategy ? getColorStrategyLockReason(selectedStrategy, currentUserId) : null;

  const handleEdit = () => {
    if (!selectedStrategy) return;
    onEdit(selectedStrategy);
  };

  const handleDelete = async () => {
    if (!selectedStrategy) return;
    await onDelete(selectedStrategy);
    setSelectedStrategyId(null); // Clear selection after delete
  };

  return (
    <Card 
      title="Color Strategy Management" 
      style={{ width: "100%" }}
    >
      <Space direction="vertical" style={{ width: "100%" }} size="medium">
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <PermissionedButton
            type="primary" 
            icon={<PlusOutlined style={{ verticalAlign: 'baseline'}} />}
            onClick={onAdd}
            permissionCheck={'AddColorStrategy'}
          >
            Add Strategy
          </PermissionedButton>
        </div>

        {/* Strategy Selection and Actions */}
        <div style={{ 
          display: "flex", 
          alignItems: "center", 
          gap: "12px", 
          flexWrap: "wrap",
          marginTop: "16px",
          paddingTop: "16px",
          borderTop: "1px solid #f0f0f0"
        }}>
          <Typography.Text strong>Select Strategy:</Typography.Text>
          <Select
            placeholder="Choose a color strategy"
            value={selectedStrategyId}
            onChange={setSelectedStrategyId}
            style={{ minWidth: 250, flex: 1 }}
            allowClear
          >
            {strategies.map((strategy) => (
              <Option key={strategy.id} value={strategy.id}>
                {strategy.name}
              </Option>
            ))}
          </Select>

          <PermissionedButton 
            icon={<EditOutlined />} 
            onClick={handleEdit}
            disabled={!selectedStrategy}
            permissionCheck={'EditColorStrategy'}
          >
            Edit
          </PermissionedButton>
          
          <Popconfirm
            title="Are you sure you want to delete this strategy?"
            onConfirm={handleDelete}
            okText="Yes"
            cancelText="No"
            disabled={!selectedStrategy || !!lockReason}
          >
            <Tooltip title={lockReason}>
              <PermissionedButton 
                icon={<DeleteOutlined />} 
                disabled={!selectedStrategy || !!lockReason} 
                danger 
                permissionCheck={'DeleteColorStrategy'}
              >
                Delete
              </PermissionedButton>
            </Tooltip>
          </Popconfirm>
        </div>
      </Space>
    </Card>
  );
}; 